import React from 'react';
import TimelineConnector from './TimelineConnector';

const OperationEntry = ({ op, showConnector, onEditOperation, onDeleteOperation, isDeleting = false }) => {
  const formatDateOnly = (value) => {
    if (!value) return '';
    const d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    return d.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <>
      <div className="list-group-item mb-0 note-card operation-card">
        <div className="note-content p-3">
          <div className="note-header-row mb-2 d-flex justify-content-between align-items-center">
            <h6 className="mb-0">
              <span className="note-date">
                <i className="fas fa-syringe me-1" aria-hidden="true"></i>
                Operation
              </span>
              <div className="small text-muted mt-1">
                Date: {formatDateOnly(op?.date)}
              </div>
            </h6>
            <div className="btn-group">
              <button
                type="button"
                className="btn btn-outline-primary btn-sm d-flex align-items-center p-2"
                onClick={() => onEditOperation && onEditOperation(op)}
                title="Edit operation"
                aria-label="Edit operation"
                style={{ minWidth: '32px', minHeight: '32px' }}
                disabled={!onEditOperation}
              >
                <i className="fas fa-edit"></i>
              </button>
              <button
                type="button"
                className="btn btn-outline-danger btn-sm d-flex align-items-center p-2"
                onClick={() => onDeleteOperation && onDeleteOperation(op?.id)}
                title="Delete operation"
                aria-label="Delete operation"
                style={{ minWidth: '32px', minHeight: '32px' }}
                disabled={!onDeleteOperation || isDeleting}
              >
                {isDeleting ? (
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                ) : (
                  <i className="fas fa-trash"></i>
                )}
              </button>
            </div>
          </div>

          <div className="note-section">
            <div className="section-title"><span className="icon">🏥</span>Operation Details</div>
            <div>
              <strong>Type:</strong> {op?.type || '-'}
              {op?.hospital ? (
                <span className="ms-3"><strong>Hospital:</strong> {op.hospital}</span>
              ) : null}
            </div>
          </div>

          {op?.clinical_notes ? (
            <div className="note-section">
              <div className="section-title"><span className="icon">📋</span>Clinical notes</div>
              <div className="note-description" style={{ lineHeight: '1.5' }} dangerouslySetInnerHTML={{ __html: op.clinical_notes }} />
            </div>
          ) : null}
        </div>
      </div>
      <TimelineConnector show={showConnector} />
    </>
  );
};

export default OperationEntry;
